import axios from "axios";
import { useEffect, useState } from "react";
import animated_profile_picture_3 from "../assets/animated_profile_picture_3.png";
const Ranks = () => {
  const [globalRanking, setGlobalRanking] = useState([]);

  useEffect(() => {
    axios.get("https://verbalvortex-server.onrender.com/auth/globalRanking").then((response) => {
      setGlobalRanking(response.data);
    });
  }, []);

  return (
    <div className="Ranks">
      <h2 id="Ranks__title">GLOBAL RANKING</h2>
      <hr />
      <div id="Ranks__RanksList">
        {globalRanking.map((user, index) => (
          <div id="Ranks__Rank">
            <div key={user.id}>
              <img src={animated_profile_picture_3} />
              <div>{user.username}</div>
              <div>Rank: {index + 1}</div>
              <div>Score: {user.score}</div>
              <div>Country: {user.country}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ranks;
